<template>
	<div>
		<h2 class="heading-2">{{ $t('jobTitles') }}</h2>
		<ja-add-button
			v-if="dataJobTitles && dataJobTitles.length < 4"
			@click.native="handleAddNewJobTitle"
			>{{ $t('addNewJobTitle') }}</ja-add-button
		>
		<table class="table-job-title">
			<thead>
				<tr class="body-text-1">
					<th class="th-question__title">
						{{ $t('jobTitle') }}
					</th>
					<th class="th-question__salary">
						{{ $t('salary') }}
					</th>
					<th class="th-question__active">
						{{ $t('active') }}
					</th>
					<th class="th-question__actions">
						{{ $t('actions') }}
					</th>
				</tr>
			</thead>
			<tr v-for="(row, index) in dataJobTitles" :key="index">
				<td colspan="4" class="td-cluster-name">
					<span class="td-span" @click="toggleAccordion(index)">
						<span
							class="arrow-icon"
							:class="
								expandedRows[index]
									? 'arrow-rotated-open'
									: 'arrow-rotated-close'
							"
						>
							{{ '▲' }}</span
						>
						{{ $t('lifeStage') + ': ' + getLifeStageName(row.lifeStage_ID) }}
					</span>
					<table v-if="expandedRows[index] && !expandedJobTitles[index]">
						<tbody class="body-text-2">
							<tr>
								<td class="th-question__title">{{ row.jobTitle }}</td>
								<td class="th-question__salary">{{ row.salary }}</td>
								<td class="th-question__active">
									{{ row.isActive ? $t('Yes') : $t('No') }}
								</td>
								<td class="th-question__actions">
									<button class="action-button" @click="editRow(row, index)">
										<svgicon name="pencil"></svgicon>
									</button>
									<button class="action-button" @click="openDeleteModal(row)">
										<svgicon name="trash"></svgicon>
									</button>
								</td>
							</tr>
						</tbody>
					</table>
					<div
						v-if="editJobTitle && expandedJobTitles[index]"
						class="job-title-edit"
					>
						<ja-input
							v-model="row.jobTitle"
							required
							:label="$t('jobTitle')"
							:name="$t('jobTitle')"
						></ja-input>
						<ja-input
							v-model="row.salary"
							:max-length="8"
							is-number-input
							required
							:label="$t('salary')"
							:name="$t('salary')"
						></ja-input>
						<ja-dropdown
							v-model="activeIndex"
							:label="$t('active')"
							:options="activeOptions"
							name="active"
							@input="handleActive(index)"
						></ja-dropdown>
						<ja-input
							:value="getLifeStageName(row.lifeStage_ID)"
							disabled
							:label="$t('lifeStage')"
							:name="$t('lifeStage')"
						></ja-input>
						<div class="container-buttons-job">
							<ja-button
								name="cancel"
								class="small"
								@click.native="cancelEditJob(index)"
								>{{ $t('cancel') }}</ja-button
							>
							<ja-button
								name="save"
								class="small outlined"
								:disabled="
									row.jobTitle &&
										row.jobTitle.length < 1 &&
										(row.salary === 0 || row.salary.length === 0)
								"
								@click.native="saveEditJob(index)"
								>{{ $t('save') }}</ja-button
							>
						</div>
					</div>
				</td>
			</tr>
		</table>

		<ja-confirm-modal
			:show="showMessageDeletionModal"
			:title="$t('confirmation')"
			:confirm-text="$t('yes')"
			:cancel-text="$t('no')"
			class="confirm-modal--medium"
			@confirm="deleteJob()"
			@closeModal="closeMessageDeletionModal()"
			@cancel="closeMessageDeletionModal()"
		>
			<h3 class="body-text-2">
				{{
					$t('deleteMessageCms', {
						title: $t('jobTitle')
					})
				}}
			</h3>
		</ja-confirm-modal>
	</div>
</template>
<script>
import CareerServices from '@/services/cms/CareerServices';
import JobTitleServices from '@/services/cms/JobTitleServices';
import AddButton from '@/components/AdminSection/elements/AddButton';
import ConfirmModal from '@/components/Modal/ConfirmModal';
import { Dropdown, Input } from '@/components/ui/form';
import Button from '@/components/ui/Button';
import { lifeStageDropdown, ID_NEW_CMS } from '@/helpers/constants';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';

export default {
	components: {
		jaConfirmModal: ConfirmModal,
		jaDropdown: Dropdown,
		jaInput: Input,
		jaButton: Button,
		jaAddButton: AddButton
	},
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			showMessageDeletionModal: false,
			dataJobTitles: null,
			rowToDelete: null,
			expandedRowIndex: null,
			editJobTitle: false,
			activeIndex: 0,
			lifeStageOptions: lifeStageDropdown,
			activeOptions: [
				{ name: this.$t('Yes'), isActive: true },
				{ name: this.$t('No'), isActive: false }
			],
			expandedRows: [],
			expandedJobTitles: []
		};
	},
	async mounted() {
		this.$store.commit('setLoading', true);
		await this.careerJobTitle();
		await this.baseJobTitle();
		this.expandedRows = this.dataJobTitles.map(() => true);
		this.expandedJobTitles = this.dataJobTitles.map(() => false);
		this.$store.commit('setLoading', false);
	},
	methods: {
		getLifeStageName(lifeStageID) {
			return this.lifeStageOptions.find(
				stage => stage.lifeStage_ID === lifeStageID
			).name;
		},
		sortLifeStageOptions(arrayToSort) {
			const sortArray = arrayToSort.sort((a, b) => {
				const indexA = this.lifeStageOptions.findIndex(
					item => item.lifeStage_ID === a.lifeStage_ID
				);
				const indexB = this.lifeStageOptions.findIndex(
					item => item.lifeStage_ID === b.lifeStage_ID
				);

				return indexA - indexB;
			});
			return sortArray;
		},
		async careerJobTitle() {
			const data = await CareerServices.getCareerJobTitlesById(
				this.data.career_ID
			);
			const newArray = data.map(item => {
				const matchingLifeStage = this.data.lifeStages.find(
					stage => stage.lifeStage_ID === item.lifeStage_ID
				);
				if (matchingLifeStage) {
					return {
						...item,
						nameLifeStage: matchingLifeStage.name
					};
				} else {
					return item;
				}
			});
			this.dataJobTitles = this.sortLifeStageOptions(newArray);
		},
		async baseJobTitle() {
			const dataBaseJobTitle = await JobTitleServices.getJobTitleById();
			dataBaseJobTitle.lifeStage_ID = this.lifeStageOptions[0].lifeStage_ID;
			dataBaseJobTitle.career_ID = this.data.career_ID;
			this.baseJobTitles = dataBaseJobTitle;
		},
		getNextAvailableLifeStageIndex() {
			const existingLifeStageIds = this.dataJobTitles.map(
				jobTitle => jobTitle.lifeStage_ID
			);

			return this.lifeStageOptions.findIndex(
				option => !existingLifeStageIds.includes(option.lifeStage_ID)
			);
		},
		handleAddNewJobTitle() {
			if (this.dataJobTitles.length === 0) {
				this.dataJobTitles.push(this.baseJobTitles);
			} else {
				const newLifeStageIndex = this.getNextAvailableLifeStageIndex();
				const newJobTitle = {
					...this.baseJobTitles,
					lifeStage_ID: this.lifeStageOptions[newLifeStageIndex].lifeStage_ID
				};
				this.dataJobTitles.push(newJobTitle);
			}
			this.toggleAccordion(this.dataJobTitles.length - 1);
			this.editRow(
				this.dataJobTitles[this.dataJobTitles.length - 1],
				this.dataJobTitles.length - 1
			);
		},
		handleActive(index) {
			this.dataJobTitles.lifeStage[index].IsActive = this.activeOptions[
				this.activeIndex
			].isActive;
		},
		cancelEditJob(index) {
			this.editJobTitle = false;
			this.toggleJobEdit(index);
			const isCreatedJob = this.dataJobTitles[index].JobTitle !== null;
			if (!isCreatedJob) {
				this.rowToDelete = this.dataJobTitles[index];
				this.deleteJob();
			}
		},
		async saveEditJob(index) {
			this.dataJobTitles[index].isActive = this.activeOptions[
				this.activeIndex
			].isActive;
			this.editJobTitle = false;
			const dataEditJob = this.dataJobTitles[index];
			this.$store.commit('setLoading', true);
			await JobTitleServices.update(dataEditJob);
			await this.careerJobTitle();
			this.toggleJobEdit(index);
			this.$store.commit('setLoading', false);
		},
		editRow(row, index) {
			this.editJobTitle = true;
			this.toggleJobEdit(index);
		},
		openDeleteModal(row) {
			this.rowToDelete = row;
			this.showMessageDeletionModal = true;
		},
		toggleAccordion(index) {
			this.$set(this.expandedRows, index, !this.expandedRows[index]);
			if (this.expandedJobTitles[index] == true) {
				this.$set(
					this.expandedJobTitles,
					index,
					!this.expandedJobTitles[index]
				);
			}
		},
		toggleJobEdit(index) {
			this.$set(this.expandedJobTitles, index, !this.expandedJobTitles[index]);
		},
		async deleteJob() {
			const isNewJob = this.rowToDelete.careerJobTitle_ID === ID_NEW_CMS;
			if (this.rowToDelete) {
				const indexToDelete = this.dataJobTitles.findIndex(obj => {
					return Object.keys(this.rowToDelete).every(key => {
						return obj[key] === this.rowToDelete[key];
					});
				});
				if (indexToDelete !== -1) {
					this.dataJobTitles.splice(indexToDelete, 1);
				}
			}
			if (!isNewJob) {
				await JobTitleServices.deleteById(this.rowToDelete.careerJobTitle_ID);
				await this.careerJobTitle();
			}
			this.showMessageDeletionModal = false;
		},
		closeMessageDeletionModal() {
			this.showMessageDeletionModal = false;
		}
	}
};
</script>
<style lang="scss" scoped>
::v-deep .add-button {
	float: right;
	padding: 10px;
}
.job-title-edit {
	padding: 15px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-evenly;
	gap: 10px;
	::v-deep .input-wrapper {
		width: 40%;
	}
	::v-deep .input-wrapper .input-container {
		width: 100%;
	}
	::v-deep .dropdown-component {
		width: 40%;
	}
}
table {
	width: 100%;
	border-collapse: collapse;
}
th,
td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

th {
	background-color: #ffff;
}
.th-question {
	&__title {
		width: 50%;
	}
	&__salary {
		width: 25%;
	}
	&__active {
		width: 15%;
	}
	&_actions {
		width: 10%;
	}
}
.td-cluster-name {
	padding: 0px;
}
.td-span {
	width: 100%;
	display: flex;
	cursor: pointer;
	height: 100%;
	padding: 10px;
	background-color: $selected-option-bgcolor;
}
.action-button {
	background-color: transparent;
	border: none;
	cursor: pointer;
	padding: 0 10px;
}
.arrow-rotated-open {
	transform: rotate(180deg);
}
.arrow-rotated-close {
	transform: rotate(0deg);
}
.arrow-icon {
	width: 30px;
	text-align: center;
	transition: transform 0.2s ease;
}
.container-buttons-job {
	margin: 15px 0 10px 0;
	display: flex;
	align-items: center;
	gap: 20px;
	flex-direction: row-reverse;
	padding-right: 60px;
	width: 100%;
}
</style>
